<template>
  <div v-if="bpTag && files">
    <h1>Buyer persona</h1>
    <v-btn :to="{ name: 'bpTagsSummary' }"
      ><v-icon>chevron_left</v-icon> Buyer personas</v-btn
    >
    <div>
      <v-chip outline :color="bpTag.colour">{{ bpTag.name }}</v-chip>
    </div>
    <v-data-table
      :pagination.sync="pagination"
      :total-items="fileCount"
      :loading="loading"
      :headers="headers"
      :items="files"
      :footer-props="{ showFirstLastPage, showCurrentPage }"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td><FileZ :file="props.item" /></td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
import FileZ from "@/components/link/FileZ";
export default {
  name: "BuyerPersona",
  metaInfo() {
    return {
      title: "Buyer persona",
      titleTemplate: "%s - File - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: {
    FileZ
  },
  data() {
    return {
      fileCount: null,
      bpTag: null,
      files: null,
      headers: [
        {
          text: "Id",
          value: "id"
        }
      ],
      loading: false,
      pagination: {
        page: 1,
        rowsPerPage: 10
      },
      showFirstLastPage: true,
      showCurrentPage: true
    };
  },
  methods: {
    async fetchBpTag() {
      const response = await nbmlaw.get(
        `/cors/admin/file/bpTags/${this.$route.params.id}`
      );
      // console.log(response.data);
      this.bpTag = response.data;
    },
    async fetchBpTagFilesCount() {
      const response = await nbmlaw.get(
        `/cors/admin/file/bpTags/${this.$route.params.id}/files/count`
      );
      // console.log(response.data)
      this.fileCount = response.data;
    },
    async fetchBpTagFiles() {
      const { sortBy, descending, page, rowsPerPage } = this.pagination;
      //   console.log("sort by: " + sortBy + ", sort descending: " + descending);
      let firstRow = (page - 1) * rowsPerPage;
      //   console.log("firstRow: " + firstRow + ", rowsPerPage: " + rowsPerPage);
      const response = await nbmlaw.get(
        `/cors/admin/file/bpTags/${this.$route.params.id}/files`,
        {
          params: {
            sortBy,
            descending,
            first: firstRow,
            pageSize: rowsPerPage
          }
        }
      );
      // console.log(response.data);
      this.files = response.data;
      this.loading = false;
    },
    update() {
      this.loading = true;
      this.fetchBpTagFilesCount();
      this.fetchBpTagFiles();
    }
  },
  watch: {
    pagination: {
      handler() {
        this.update();
      },
      deep: true
    }
  },
  created() {
    this.fetchBpTag();
    this.update();
  }
};
</script>